<template>
    <div>
        <date-picker v-model="checkoutDate" input-class="form-control vue-email_screen sd" valueType="format"
            :editable="false" :clearable="false" :disabled-date="disableDateBeforeCheckin" @change="handleCheckOutDate"></date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
    props: ['stayrestrictions'],
    components: {
        'date-picker': DatePicker
    },
    computed: {
        ...mapGetters(['checkinDate', 'checkoutDate']),
        calculatedCheckoutDate() {
            const minNights = this.getMinNights();
            if (this.checkinDate) {
                return moment(this.checkinDate).add(minNights, 'days').format('YYYY-MM-DD');
            }
            return null;
        }
    },
     watch: {
        // checkoutDate: 'updateCheckoutDate',
    },
    methods: {
        ...mapActions(['updateDates']),
        disableDateBeforeCheckin(date) {
            const today = moment().startOf('day').toDate();
            const checkin = this.checkinDate ? moment(this.checkinDate).startOf('day').toDate() : null;
            const minNights = this.getMinNights();

            if (checkin) {
                const earliestCheckoutDate = moment(checkin).add(minNights - 1, 'days').toDate();
                return date < today || date <= earliestCheckoutDate;
            }
            return date < today;
        },
        handleCheckOutDate(date) {
            this.updateDates({
                checkin_date: this.checkinDate,
                checkout_date: date
            });

            this.$emit('checkout-date-changed', date);
        },
        getMinNights() {
            let minNights = 1; // default
            if (!this.stayrestrictions || this.stayrestrictions.length == 0) {
                return minNights;
            }

            for (const stayrestriction of this.stayrestrictions) {
                let startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD');
                let enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD');
                if (moment(this.checkinDate).isBetween(startdate, enddate)) {
                    minNights = stayrestriction.minimum_nights;
                    break;
                }
            }
            return minNights;
        },
        updateCheckoutDate() {
            const newCheckoutDate = this.calculatedCheckoutDate;
            if (newCheckoutDate && newCheckoutDate !== this.checkoutDate) {
                this.updateDates({
                    checkin_date: this.checkinDate,
                    checkout_date: newCheckoutDate
                });

                this.$emit('checkout-date-changed', this.checkinDate);
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/dates/checkoutDate.vue